import { Box } from '@mui/material';
import styles from '../Layout/Layout.module.scss'; // Share scss files

export const PrintView = () => {
  return <Box className={styles['protected-container']}></Box>;
};
